// extracted by mini-css-extract-plugin
export default {"button":"CopyButton_button__uTtw1","bordered":"CopyButton_bordered__qAq50","borderless":"CopyButton_borderless__Qut6a"};